
      import API from "!../../ms/msAdmin/client/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../ms/msAdmin/client/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../ms/msAdmin/client/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../ms/msAdmin/client/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../ms/msAdmin/client/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../ms/msAdmin/client/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../ms/msAdmin/client/node_modules/css-loader/dist/cjs.js!./CompsAi.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../ms/msAdmin/client/node_modules/css-loader/dist/cjs.js!./CompsAi.css";
       export default content && content.locals ? content.locals : undefined;
